import { legacyPlugins } from "/app/node_modules/.pnpm/@unhead+vue@3.4.0_@oxc-project+types@0.151.0_esbuild@0.28.2_lightningcss@1.33.0_oxc-par_0639694dba0839aec33c2e7968b15c6d/node_modules/@unhead/vue/dist/legacy.mjs";
export default {
  disableDefaults: true,
  plugins: legacyPlugins,
}